import React, { useState, useMemo, useEffect, useRef } from 'react';
import LocalIcon from './LocalIcon';

const CategoryFilter = ({ taxonomyData, onFilterChange, selectedCategories, isPOICategoryFilterEnabled = true, onPanelOpen }) => {
 const [isDropdownOpen, setIsDropdownOpen] = useState(false);
 const dropdownRef = useRef(null);

 useEffect(() => {
   const handleClickOutside = (event) => {
     if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
       setIsDropdownOpen(false);
     }
   };

   document.addEventListener('mousedown', handleClickOutside);
   return () => document.removeEventListener('mousedown', handleClickOutside);
 }, []);

 const categories = useMemo(() => {
   return Object.entries(taxonomyData).map(([id, data]) => ({
     id,
     title: data.title,
     icon: data.icon,
     pin: data.pin,
     color: data.field_colore?.[0]?.color || '#1E88E5'
   }));
 }, [taxonomyData]);

 const handleCategoryToggle = (categoryId) => {
   const newSelectedCategories = new Set(selectedCategories);
   
   if (newSelectedCategories.has(categoryId)) {
     newSelectedCategories.delete(categoryId);
   } else {
     newSelectedCategories.add(categoryId);
   }

   onFilterChange(newSelectedCategories);
 };

 const handleDropdownToggle = () => {
   const newIsOpen = !isDropdownOpen;
   setIsDropdownOpen(newIsOpen);
   if (newIsOpen && onPanelOpen) {
     onPanelOpen();
   }
 };

 if (!isPOICategoryFilterEnabled || categories.length === 0) return null;

 return (
   <div ref={dropdownRef} style={{ position: 'absolute', top: '6px', left: '8px', zIndex: 1000, width: '40px' }}>
     <button
       aria-label="Filtra Categorie"
       className="btn bg-white border rounded-circle d-flex align-items-center justify-content-center shadow-sm opacity-75"
       style={{ width: '40px', height: '40px' }}
       onClick={handleDropdownToggle}
     >
       <LocalIcon icon="filter_alt" />
     </button>

     {isDropdownOpen && (
       <div className="category-dropdown" style={{
         position: 'absolute',
         top: '48px',
         left: '0',
         backgroundColor: 'var(--color-background-primary)',
         borderRadius: '12px',
         boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
         padding: '8px',
         width: '250px',
         //maxHeight: '300px',
         overflowY: 'auto',
         animation: 'slideIn 0.3s ease forwards'
       }}>
         <ul className="list-unstyled m-0">
           {categories.map((category) => (
             <li 
               key={category.id}
               className={`d-flex align-items-center p-2 rounded ${selectedCategories.has(category.id) ? 'bg-light' : ''}`}
               onClick={() => handleCategoryToggle(category.id)}
               style={{ cursor: 'pointer' }}
             >
               {category.icon ? (
                 <img src={category.icon} alt={category.title} style={{ width: '24px', height: '24px', marginRight: '10px', borderRadius: '4px' }} />
               ) : (
                 <div style={{
                   width: '24px',
                   height: '24px',
                   marginRight: '10px',
                   backgroundColor: category.color,
                   borderRadius: '4px'
                 }} />
               )}
               <span className="flex-grow-1 text-start" style={{ fontFamily: 'Titillium Web, sans-serif', fontSize: '0.875rem' }}>
                 {category.title}
               </span>
               {selectedCategories.has(category.id) && (
                 <LocalIcon icon="check" style={{ fontSize: '18px', color: 'var(--color-text-base)' }} />
               )}
             </li>
           ))}
           {selectedCategories.size > 0 && (
             <li 
               className="d-flex align-items-center p-2 mt-2 text-muted"
               style={{ cursor: 'pointer', borderTop: '1px solid #eee' }}
               onClick={() => onFilterChange(new Set())}
             >
               Rimuovi tutti i filtri
             </li>
           )}
         </ul>
       </div>
     )}

     <style>{`
       @keyframes slideIn {
         from { opacity: 0; transform: translateY(-10px); }
         to { opacity: 1; transform: translateY(0); }
       }
     `}</style>
   </div>
 );
};

export default CategoryFilter;